<template>
    <div :class="['message-tip', { hidden: hidden }]" :style="{ '--transition': `${transition}s` }" v-if="show">
        <div class="message-content">
            <i class="iconfont" v-if="type === 'success'">&#xe637;</i>
            <span>{{ message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BasicDrawer",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        duration: {
            type: Number,
            default: 1500,
        },
        transition: {
            type: Number,
            default: 0.22,
        },
        type: {
            type: String,
            default: "success",
        },
        message: {
            type: String,
            default: "提交成功",
        },
    },
    data() {
        return {
            hidden: false,
        };
    },
    watch: {
        show(newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.hidden = true;

                    this.close();
                }, this.duration);
            }
        },
    },
    methods: {
        close() {
            setTimeout(() => {
                this.$emit("close");
                this.hidden = false;
            }, this.transition * 1000);
        },
    },
};
</script>

<style scoped lang="scss">
.message-tip {
    position: absolute;
    inset: 0;
    // background: rgba(0, 0, 0, 0.6);
    overflow: hidden;

    &.hidden {
        .message-content {
            opacity: 0;
            transition: opacity var(--transition);
        }
    }

    .message-content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        width: 100px;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.75);
        border-radius: 10px;
        color: #ffffff;

        .iconfont {
            font-size: 32px;
        }
    }

    @keyframes show {
        from {
        }

        to {
        }
    }
}
</style>
